const initialState = {
  isAppRendered: false,
  dropdownsVisibility: {},
  areAppActionsDisabled: false,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'SET_RENDERED_APP_STATE': {
      return {
        ...state,
        isAppRendered: action.payload.isAppRendered,
      }
    }
    case 'SET_DROPDOWNS_VISIBILITY': {
      return {
        ...state,
        dropdownsVisibility: action.payload.dropdownsVisibility,
      }
    }
    case 'SET_APP_ACTIONS_DISABLED_STATE': {
      return {
        ...state,
        areAppActionsDisabled: action.payload.areAppActionsDisabled,
      }
    }
    default: {
      return state
    }
  }
}
